import React from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"

const OperationsPrint = () => {

 return(
<React.Fragment>
    <div className="text-align-center mt-4 mb-4">
        No Records Found
    </div>
</React.Fragment>
    )
}


const mapDispatchToProps = (dispatch) => {
    return {
      dispatch,
    }
  }
  
  const mapStateToProps = () => ({
    //mapstate to prop
  })
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OperationsPrint)
  )


